export var ChainId;
(function (ChainId) {
    ChainId[ChainId["CRONOS_ZK_MAINNET"] = 388] = "CRONOS_ZK_MAINNET";
    ChainId[ChainId["CRONOS_ZK_TESTNET"] = 240] = "CRONOS_ZK_TESTNET";
    ChainId[ChainId["CRONOS_EVM_MAINNET"] = 25] = "CRONOS_EVM_MAINNET";
    ChainId[ChainId["CRONOS_EVM_TESTNET"] = 338] = "CRONOS_EVM_TESTNET";
})(ChainId || (ChainId = {}));
export const CHAIN_IDS = Object.values(ChainId).filter((v) => typeof v === 'number');
export const L2_CHAIN_IDS = [
    ChainId.CRONOS_ZK_MAINNET,
    ChainId.CRONOS_ZK_TESTNET,
];
export const CRONOS_EVM_CHAIN_IDS = [
    ChainId.CRONOS_EVM_MAINNET,
    ChainId.CRONOS_EVM_TESTNET,
];
export function isChainIdL2(chainId) {
    return L2_CHAIN_IDS.includes(chainId);
}
export function isChainIdCronosEvm(chainId) {
    return CRONOS_EVM_CHAIN_IDS.includes(chainId);
}
export var ChainLayer;
(function (ChainLayer) {
    ChainLayer["L2"] = "L2";
    ChainLayer["CronosEvm"] = "CronosEvm";
})(ChainLayer || (ChainLayer = {}));
export var ChainNetwork;
(function (ChainNetwork) {
    ChainNetwork["mainnet"] = "mainnet";
    ChainNetwork["testnet"] = "testnet";
})(ChainNetwork || (ChainNetwork = {}));
